export default __webpack_public_path__ + "static/media/WStore_Icon_Wetumpka.9c74972b.png";